import * as types from './actionTypes';
import $ from 'jquery';

const service = url + 'wp-json/wp/v2/';
const afc = url + 'wp-json/acf/v2/term/';
const form1 = url + 'gravityformsapi/forms/1/submissions/?api_key=ffded1e445';
const form2 = url + 'gravityformsapi/forms/2/submissions/?api_key=ffded1e445';
const form3 = url + 'gravityformsapi/forms/3/submissions/?api_key=ffded1e445';

export function showMenu(showMenu) {
    return { type: types.SHOW_MENU, showMenu };
}

export function showNavBar(showNavBar) {
    return { type: types.SHOW_NAVBAR, showNavBar };
}

export function startTransition(startTransition) {
    return { type: types.START_TRANSITION, startTransition };
}

export function endTransition(endTransition) {
    return { type: types.END_TRANSITION, endTransition };
}

export function selectService(slug) {
    return { type: types.SELECT_SERVICE, slug };
}

export function selectPortfolio(slug) {
    return { type: types.SELECT_PORTFOLIO, slug };
}

export function loadSkillsetsSuccess(services) {
    return { type: types.LOAD_SKILLSETS, services };
}

export function loadSpecialismsSuccess(services) {
    return { type: types.LOAD_SPECIALISMS, services };
}

export function loadServiceSuccess(acf, service) {
    return { type: types.LOAD_SERVICE_SUCCESS, acf, service };
}

export function loadServicePortfoliosSuccess(service, number, page, s) {
    let slug;
    s ? slug = s : slug = false;
    return { type: types.LOAD_SERVICE_PORTFOLIOS_SUCCESS, service, number, page, slug };
}

export function loadServiceClientsSuccess(service, number, page, s) {
    let slug;
    s ? slug = s : slug = false;
    return { type: types.LOAD_SERVICE_CLIENTS_SUCCESS, service, number, page, slug };
}

export function loadPostsSuccess(posts, page, filter) {
    return { type: types.LOAD_POSTS_SUCCESS, posts, page, filter };
}


export function searchingPortfolios() {
    return { type: types.SEARCHING_PORTFOLIOS };
}

export function searchingPortfoliosSuccess(portfolios, page, filter) {
    return { type: types.SEARCHING_PORTFOLIOS_SUCCESS, portfolios, page, filter };
}

export function loadPostSuccess(post) {
    return { type: types.LOAD_POST_SUCCESS, post };
}
export function loadAboutSuccess(page) {
    return { type: types.LOAD_ABOUT_SUCCESS, page };
}
export function loadTermsSuccess(page) {
    return { type: types.LOAD_TERMS_SUCCESS, page };
}
export function loadPrivacySuccess(page) {
    return { type: types.LOAD_PRIVACY_SUCCESS, page };
}

export function getServiceByType(sType) {
    return { type: types.GET_SERVICE_BY_TYPE, sType };
}

export function pageChange(prev, next, callback) {
    return { type: types.PAGE_CHANGE, prev, next, callback };
}

export function clearState() {
    return { type: types.CLEAR_STATE };
}

export function loadingPosts() {
    return { type: types.LOADING_POSTS };
}
export function loadingAbout() {
    return { type: types.LOADING_ABOUT };
}
export function loadingPost() {
    return { type: types.LOADING_POST };
}
export function loadingPortfolio() {
    return { type: types.LOADING_PORTFOLIO };
}
export function clearSelectedService() {
    return { type: types.CLEAR_SELECTED_SERVICE };
}
export function sendingStartProject() {
    return { type: types.SENDING_START_PROJECT };
}
export function sentStartProject() {
    return { type: types.SENT_START_PROJECT };
}
export function sendingEnquiry() {
    return { type: types.SENDING_ENQUIRY };
}
export function sentEnquiry() {
    return { type: types.SENT_ENQUIRY };
}
export function sendingFeedback() {
    return { type: types.SENDING_FEEDBACK };
}
export function sentFeedback() {
    return { type: types.SENT_FEEDBACK };
}

export function sendStartProject(data) {
    return function (dispatch) {
        dispatch(sendingStartProject());
        $.ajax({
            method: "POST",
            // type: "POST",
            url: form1,
            data: JSON.stringify(data),
            dataType: "json",
        }).done(function () {
            dispatch(sentStartProject());
        });
    };
}

export function sendEnquiry(data) {
    return function (dispatch) {
        dispatch(sendingEnquiry());
        $.ajax({
            method: "POST",
            // type: "POST",
            url: form2,
            data: JSON.stringify(data),
            dataType: "json",
        }).done(function () {
            dispatch(sentEnquiry());
        });
    };
}
export function sendFeedback(data) {
    return function (dispatch) {
        dispatch(sendingFeedback());
        $.ajax({
            method: "POST",
            // type: "POST",
            url: form3,
            data: JSON.stringify(data),
            dataType: "json",
        }).done(function () {
            dispatch(sentFeedback());
        });
    };
}

export function loadServices() {
    if (data.site.specialisms.length > 1 && data.site.skillsets.length > 1) {
        return function (dispatch) {
            dispatch(loadSkillsetsSuccess(data.site.skillsets));
            dispatch(loadSpecialismsSuccess(data.site.specialisms));
        }
    } else {
        return function (dispatch) {
            $.ajax({
                url: service + 'skillsets'
            }).done(function (data) {
                dispatch(loadSkillsetsSuccess(data));
            });
            $.ajax({
                url: service + 'specialisms'
            }).done(function (data) {
                dispatch(loadSpecialismsSuccess(data));
            });
        };
    }
}

export function searchPortfolios(text, n = 20, p = 1) {

    return function (dispatch) {
        dispatch(searchingPortfolios());

        $.ajax({
            url: service + 'portfolios?filter[orderby]=menu-order&order=asc&per_page=' + n + '&page=' + p + '&search=' + text
        }).done(function (data) {
            dispatch(searchingPortfoliosSuccess(data, n, p));
        });

    };
}

export function loadService(obj, n = 20, p = 1) {

    return function (dispatch) {
        dispatch(loadingPortfolio());
        if (obj) {
            var id = obj.id ? obj.id : obj.term_id;
            $.ajax({
                url: afc + obj.taxonomy + '/' + id
            }).done(function (data) {
                dispatch(loadServiceSuccess(data.acf, obj));
            });
            $.ajax({
                url: service + 'portfolios?filter[orderby]=menu-order&order=asc&filter[' + obj.taxonomy + ']=' + obj.slug + '&per_page=' + n + '&page=' + p
            }).done(function (data) {
                dispatch(loadServicePortfoliosSuccess(data, n, p, obj.slug));
            });
            $.ajax({
                url: service + 'clients?filter[orderby]=menu-order&order=asc&filter[' + obj.taxonomy + ']=' + obj.slug + '&per_page=' + n + '&page=' + p
            }).done(function (data) {
                dispatch(loadServiceClientsSuccess(data, n, p, obj.slug));
            });
        } else {
            $.ajax({
                url: service + 'portfolios?filter[orderby]=menu-order&order=asc&per_page=' + n + '&page=' + p
            }).done(function (data) {
                dispatch(loadServicePortfoliosSuccess(data, n, p));
            });
            $.ajax({
                url: service + 'clients?filter[orderby]=menu-order&order=asc&per_page=' + n + '&page=' + p
            }).done(function (data) {
                dispatch(loadServiceClientsSuccess(data, n, p));
            });
        }
    };
}

export function loadBlogPosts(n, p) {
    return function (dispatch) {
        dispatch(loadingPosts());
        $.ajax({
            url: service + 'posts?&orderby=date&order=asc&per_page=' + n + '&page=' + p
        }).done(function (data) {
            dispatch(loadPostsSuccess(data, p));
        });
    };
}
export function loadPostsByService(slug, taxonomy, n, p) {
    return function (dispatch) {
        dispatch(loadingPosts());
        $.ajax({
            url: service + 'posts?filter[' + taxonomy + ']=' + slug + '&per_page=' + n + '&page=' + p
        }).done(function (data) {
            dispatch(loadPostsSuccess(data, p, {
                slug: slug,
                taxonomy: taxonomy
            }));
        });
    };
}

export function loadBlogPost(slug) {
    return function (dispatch) {
        dispatch(loadingPost());
        $.ajax({
            // url: service + 'posts?filter[name]='+ slug + '&_embed'
            url: service + 'posts/' + slug
        }).done(function (data) {
            if (data.length > 0) {
                dispatch(loadPostSuccess(data[0]));
            } else {
                dispatch(loadPostSuccess(data));
            }
        });
    };
}
export function loadAboutPage(slug) {
    return function (dispatch) {
        dispatch(loadingAbout());
        $.ajax({
            url: service + 'pages/28'
        }).done(function (data) {
            dispatch(loadAboutSuccess(data));
        });
    };
}
export function loadPrivacyPage(slug) {
    return function (dispatch) {
        dispatch(loadingAbout());


        $.ajax({
            url: service + 'pages/1252'
        }).done(function (data) {
            dispatch(loadPrivacySuccess(data));
        });
    };
}
export function loadTermsPage(slug) {
    return function (dispatch) {
        dispatch(loadingAbout());


        $.ajax({
            url: service + 'pages/1255'
        }).done(function (data) {
            dispatch(loadTermsSuccess(data));
        });
    };
}

export function loggingIn(post) {
    return { type: types.USER_LOGGING_IN };
}

export function userLogout() {
    return { type: types.USER_LOGOUT };
}

export function loginSuccess(user) {
    return { type: types.USER_LOGIN_SUCCESS, user };
}

export function loginFailed(error) {
    return { type: types.USER_LOGIN_FAILED, error };
}

export function checkUser() {
    return { type: types.CHECK_USER };
}

export function getUserToken(user) {
    return function (dispatch) {
        dispatch(loggingIn());
        $.ajax({
            url: url + 'wp-json/jwt-auth/v1/token',
            type: 'POST',
            data: {
                username: user.username,
                password: user.password
            }
        }).done(function (data) {
            dispatch(loginSuccess(data));
        }).catch(function (err) {
            dispatch(loginFailed(err.responseJSON));
        });
    };
}

export function privateSearchPortfolios(text, n = 20, p = 1) {

    return function (dispatch) {
        if (sessionStorage.getItem('user')) {
            let token = JSON.parse(sessionStorage.getItem('user')).token;

            dispatch(searchingPortfolios());

            $.ajax({
                url: url + 'wp-json/client/portfolios?filter[orderby]=menu-order&order=asc&per_page=' + n + '&page=' + p + '&search=' + text,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                }
            }).done(function (data) {
                dispatch(searchingPortfoliosSuccess(data, n, p));
            });
        } else {
            dispatch(userLogout());
        }
    };
}

export function loadPrivateService(obj, n = 20, p = 1) {

    return function (dispatch) {
        if (sessionStorage.getItem('user')) {
            let token = JSON.parse(sessionStorage.getItem('user')).token;

            dispatch(loadingPortfolio());
            if (obj) {
                let id = obj.id ? obj.id : obj.term_id;
                $.ajax({
                    url: afc + obj.taxonomy + '/' + id
                }).done(function (data) {
                    dispatch(loadServiceSuccess(data.acf, obj));
                });
                $.ajax({
                    url: url + 'wp-json/client/portfolios?filter[orderby]=menu-order&order=asc&filter[' + obj.taxonomy + ']=' + obj.slug + '&per_page=' + n + '&page=' + p,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    }
                }).done(function (data) {
                    dispatch(loadServicePortfoliosSuccess(data, n, p, obj.slug));
                });
                $.ajax({
                    url: service + 'clients?filter[orderby]=menu-order&order=asc&filter[' + obj.taxonomy + ']=' + obj.slug + '&per_page=' + n + '&page=' + p
                }).done(function (data) {
                    dispatch(loadServiceClientsSuccess(data, n, p, obj.slug));
                });
            } else {

                $.ajax({
                    url: url + 'wp-json/client/portfolios?filter[orderby]=menu-order&order=asc&per_page=' + n + '&page=' + p,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    }
                }).done(function (data) {
                    dispatch(loadServicePortfoliosSuccess(data, n, p));
                });
                $.ajax({
                    url: service + 'clients?filter[orderby]=menu-order&order=asc&per_page=' + n + '&page=' + p
                }).done(function (data) {
                    dispatch(loadServiceClientsSuccess(data, n, p));
                });
            }
        } else {
            dispatch(userLogout());
        }
    };
}

export function loadBusinessTermsPage(slug) {
    return function (dispatch) {
        // dispatch(loadingAbout());
        $.ajax({
            url: service + 'pages/1300'
        }).done(function (data) {
            dispatch(loadTermsSuccess(data));
        });
    };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/siteActions.js
 **/